/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see [https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script](https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script)
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-text-to-speech block)");
/* eslint-enable no-console */

/**
 * Text-to-Speech Block - Version Mobile Chrome Fixée
 * Fixes : texte long (23k+), voix anglaise auto, synthesis-failed
 */

(function () {
    const synth = window.speechSynthesis;
    const $ = id => document.getElementById(id);

    const textarea = $('tts-input');
    const voiceSel = $('voice-select');
    const rateS = $('rate-slider');
    const pitchS = $('pitch-slider');
    const volS = $('vol-slider');
    const rateV = $('rate-val');
    const pitchV = $('pitch-val');
    const volV = $('vol-val');
    const btnPlay = $('btn-play');
    const playIcon = $('play-icon');
    const btnStop = $('btn-stop');
    const btnSettings = $('btn-settings');
    const accordion = $('settings-accordion');
    const dot = $('dot');
    const statusTxt = $('status-txt');
    const progWrap = $('prog-wrap');
    const progBar = $('prog-bar');

    let voices = [],
        charTotal = 0,
        chunks = [],       // liste des parties
        chunkIndex = 0;    //

    // FIX #1 : Découpage texte long pour mobile (23k+ chars)
    function splitTextForMobile(text, maxChars = 4000) {
        if (text.length <= maxChars) return [text];
        const sentences = text.split(/[.!?]+/).filter(s => s.trim());
        const chunks = [];
        let currentChunk = '';
        sentences.forEach(sentence => {
            if ((currentChunk + sentence).length > maxChars) {
                if (currentChunk) chunks.push(currentChunk.trim() + '.');
                currentChunk = sentence;
            } else {
                currentChunk += (currentChunk ? ' ' : '') + sentence;
            }
        });
        if (currentChunk) chunks.push(currentChunk.trim() + '.');
        return chunks;
    }

    function loadVoices() {
        voices = synth.getVoices();
        voiceSel.innerHTML = '';
        if (!voices.length) {
            voiceSel.innerHTML = '<option>No voice available</option>';
            return;
        }

        const en = voices.filter(v => v.lang.startsWith('en'));
        const fr = voices.filter(v => v.lang.startsWith('fr'));
        const other = voices.filter(v => !v.lang.startsWith('en') && !v.lang.startsWith('fr'));

        const addG = (label, list) => {
            if (!list.length) return;
            const g = document.createElement('optgroup');
            g.label = label;
            list.forEach(v => {
                const o = document.createElement('option');
                o.value = v.name;
                o.textContent = v.name + ' (' + v.lang + ')';
                g.appendChild(o);
            });
            voiceSel.appendChild(g);
        };
        addG('English (priorité)', en); // ANGLAIS EN 1er !
        addG('Français', fr);
        addG('Autres', other);

        // FIX #2 : Voix anglaise locale par défaut
        const preferred = voices.find(v => v.lang.startsWith('en-US') && v.localService) ||
            voices.find(v => v.lang.startsWith('en') && v.localService) ||
            voices.find(v => v.lang.startsWith('en')) ||
            voices[0];
        if (preferred) voiceSel.value = preferred.name;
    }

    // Load voices robuste mobile
    loadVoices();
    synth.getVoices();
    if (speechSynthesis.onvoiceschanged !== undefined) {
        speechSynthesis.onvoiceschanged = () => {
            loadVoices();
            voices = synth.getVoices();
        };
    }

    function updateSlider(input, display, fmt) {
        const min = parseFloat(input.min), max = parseFloat(input.max), val = parseFloat(input.value);
        input.style.setProperty('--pct', ((val - min) / (max - min) * 100).toFixed(1) + '%');
        display.textContent = fmt(val);
    }
    rateS.addEventListener('input', () => updateSlider(rateS, rateV, v => v.toFixed(2) + 'x'));
    pitchS.addEventListener('input', () => updateSlider(pitchS, pitchV, v => v.toFixed(2)));
    volS.addEventListener('input', () => updateSlider(volS, volV, v => Math.round(v * 100) + '%'));
    updateSlider(rateS, rateV, v => v.toFixed(2) + 'x');
    updateSlider(pitchS, pitchV, v => v.toFixed(2));
    updateSlider(volS, volV, v => Math.round(v * 100) + '%');

    btnSettings.addEventListener('click', () => {
        const open = accordion.classList.toggle('open');
        btnSettings.setAttribute('aria-expanded', open);
    });

    const ICON_PLAY = '<path d="M8 5v14l11-7z"/>';
    const ICON_PAUSE = '<path d="M6 19h4V5H6zm8-14v14h4V5z"/>';

    function setStatus(type, msg) { dot.className = 'dot ' + type; statusTxt.textContent = msg; }
    function setProgress(p) { progWrap.classList.toggle('on', p > 0 && p < 100); progBar.style.width = p + '%'; }
    function setPlayBtn(state) {
        if (state === 'playing') {
            playIcon.innerHTML = ICON_PAUSE;
            btnPlay.setAttribute('aria-label', 'Pause');
            btnPlay.title = 'Pause';
        } else if (state === 'paused') {
            playIcon.innerHTML = ICON_PLAY;
            btnPlay.setAttribute('aria-label', 'Reprendre');
            btnPlay.title = 'Reprendre';
        } else {
            playIcon.innerHTML = ICON_PLAY;
            btnPlay.setAttribute('aria-label', 'Jouer');
            btnPlay.title = 'Jouer';
        }
        btnStop.disabled = (state === 'idle');
    }

    btnPlay.addEventListener('click', () => {
        if (synth.paused && synth.speaking) {
            synth.resume();
            setStatus('playing', 'Lecture...');
            setPlayBtn('playing');
            return;
        }
        if (synth.speaking && !synth.paused) {
            synth.pause();
            setStatus('paused', 'Pause');
            setPlayBtn('paused');
            return;
        }

        let text = textarea.value.trim();
        if (!text) {
            setStatus('error', 'Aucun texte !');
            return;
        }

        chunks = splitTextForMobile(text);   // stock global
        text = chunks[0];
        chunkIndex = 0;
        if (chunks.length > 1) {
            setStatus('info', `Partie 1/${chunks.length}`);
        }

        voices = synth.getVoices();
        if (!voices.length) {
            setStatus('error', 'Voix indisponibles. Retry.');
            synth.onvoiceschanged = () => btnPlay.click();
            return;
        }

        synth.cancel();

        const utt = new SpeechSynthesisUtterance(text);
        charTotal = text.length;

        let selectedVoice = voices.find(v => v.name === voiceSel.value);
        if (!selectedVoice || !selectedVoice.localService) {
            selectedVoice = voices.find(v => v.lang.startsWith('en') && v.localService) ||
                voices.find(v => v.lang.startsWith('en')) ||
                voices[0];
            if (selectedVoice) voiceSel.value = selectedVoice.name;
        }
        if (selectedVoice) utt.voice = selectedVoice;

        utt.lang = selectedVoice?.lang || 'en-US'; // ANGLAIS !
        utt.rate = Math.min(1.5, parseFloat(rateS.value));
        utt.pitch = parseFloat(pitchS.value);
        utt.volume = parseFloat(volS.value);

        utt.onstart = () => {
            setStatus('playing', 'Lecture...');
            setPlayBtn('playing');
            setProgress(1);
        };
        utt.onboundary = e => {
            if (e.name === 'word' && charTotal > 0)
                setProgress(Math.round(e.charIndex / charTotal * 100));
        };
        utt.onend = () => {
            setStatus('idle', 'Terminé');
            if (chunks.length > 1 && chunkIndex < chunks.length - 1) {
                chunkIndex++;
                setStatus('info', `Partie ${chunkIndex + 1}/${chunks.length}`);
                charTotal = chunks[chunkIndex].length;
                const nextUtt = new SpeechSynthesisUtterance(chunks[chunkIndex]);
                nextUtt.voice = selectedVoice;
                nextUtt.lang = selectedVoice?.lang || 'en-US';
                nextUtt.rate = Math.min(1.5, parseFloat(rateS.value));
                nextUtt.pitch = parseFloat(pitchS.value);
                nextUtt.volume = parseFloat(volS.value);
                nextUtt.onstart = () => {
                    setStatus('playing', 'Lecture...');
                    setPlayBtn('playing');
                    setProgress(1);
                };
                nextUtt.onboundary = e => {
                    if (e.name === 'word' && charTotal > 0)
                        setProgress(Math.round(e.charIndex / charTotal * 100));
                };
                nextUtt.onend = arguments.callee; // ou refaire la même logique
                nextUtt.onerror = e => {
                    if (e.error === 'interrupted') return;
                    setStatus('error', `Erreur: ${e.error}`);
                    setPlayBtn('idle');
                    setProgress(0);
                };
                synth.speak(nextUtt);
            } else {
                setPlayBtn('idle');
                setProgress(0);
                progWrap.classList.remove('on');
            }
        };
        utt.onerror = e => {
            if (e.error === 'interrupted') return;
            setStatus('error', `Erreur: ${e.error}`);
            setPlayBtn('idle');
            setProgress(0);
            if (navigator.userAgent.includes('Mobile')) {
                alert(`Erreur: ${e.error}\nVoix: ${voices.length}\n${selectedVoice?.name || 'aucune'}\n${text.length} chars`);
            }
        };

        synth.speak(utt);
    });

    btnStop.addEventListener('click', () => {
        synth.cancel();
        setStatus('idle', 'Arrêté');
        setPlayBtn('idle');
        setProgress(0);
        progWrap.classList.remove('on');
    });

    window.addEventListener('beforeunload', () => synth.cancel());
})();